import { DashboardCard } from "./DashboardCard"

interface DashboardCardWrapperProps {
  category: string
  metrics: any[]
  description: string
}

export function DashboardCardWrapper({ category, metrics, description }: DashboardCardWrapperProps) {
  return (
    <>
      <div className="relative">
        <DashboardCard category={category} metrics={metrics} description={description} />
      </div>
    </>
  )
}